import React from "react"

import FinancialHeaderComponent from "./financial-header-component"

class FinancialHeaderContainer extends React.Component {
	render() {
		return (
			<FinancialHeaderComponent {...this.props} />
		)
	}

}

export default FinancialHeaderContainer



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/grants/financial-header-container.js